/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Sc_InboxInputs */

const en_mk_tut_sc_inbox = /** @type {(inputs: Mk_Tut_Sc_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to the Inbox`)
};

const id_mk_tut_sc_inbox = /** @type {(inputs: Mk_Tut_Sc_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lompat ke Inbox`)
};

/**
* | output |
* | --- |
* | "Jump to the Inbox" |
*
* @param {Mk_Tut_Sc_InboxInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_sc_inbox = /** @type {((inputs?: Mk_Tut_Sc_InboxInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Sc_InboxInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_sc_inbox(inputs)
	return en_mk_tut_sc_inbox(inputs)
});